import { makeRoute } from "@/lib/makeRoute";

export const Route = makeRoute("/nl/tools", "nl", "tools");
